<!--  -->
<template>
  <div class="contianer">
    <div class="con">
      <img
        class="bgimg"
        src="../../assets/images/plus/topbg.png"
        alt=""
      />
      <div class="btnbox">
        <img src="../../assets/images/plus/bt1.png" v-if="ifplus" alt="" @click="goPlus()">
        <img src="../../assets/images/plus/bt2.png" v-else alt="" @click="goto('19192',false)">
      </div>
      <div class="ptitle">
        <img src="../../assets/images/plus/icon1.png" alt="">
        <div>PLUS会员好物推荐 / 天天超值兑换</div>
      </div>
      <div class="plist">
        <div class="pbox" v-for="(item,index) in productLists" :key="index">
          <div @click="goto(item.id,true)">
            <img :src="item.pictureUrl" alt="">
            <div class="title">
              <img class="proicon" src="../../assets/images/plus/proicon.png" alt=""/>
              {{item.chineseName}}
            </div>
            <div class="jf">{{item.recommendRetailPrice}}积分</div>
          </div>
        </div>
      </div>
       <div class="ptitle">
      <img class="icon2" src="../../assets/images/plus/icon2.png" alt="">
       </div>

    </div>
     <img
      class="backtop"
      :src="require('@/assets/images/plus/backtop.png')"
      @click="backTop(50)"
      v-show="toTop"
    />
  </div>
</template>

<script>
import{ isMemberPlus,findPlusProductList}  from "../../api/api";
export default {
  data(){
    return {
      ifplus:false,
      productLists:[],
      toTop: false, //是否显示回到顶部
      timer: null,
      ip: "",

    }
  },
  methods: {
    goto(id,type) {
      if(!this.ifplus && type){
        this.$toast("暂时无法兑换该商品，请先开通PLUS会员");
        return;
      }
      let position = window.scrollY
      this.$router.push({ query: { page: position } });
      this.$router.push({
        path: "/productDetails?id=" + id,
      });
    },
    goPlus() {
      // const userAgent = navigator.userAgent.toLocaleLowerCase();

      // if (userAgent.includes("uplus") || userAgent.includes("sybird")) {
      //   this.instance.upVdnModule
      //     .goToPageForResult({
      //       url:
      //         // "mpaas://haierVipCode?needAuthLogin=1#/cn/distcord/payingMember",
      //         "mpaas://haierVipCode?needAuthLogin=1#/cn/distcord/payingMember",

      //     })
      //     .then(
      //       (res) => {
      //         console.log("result", res);
      //       },
      //       (err) => {
      //         console.log("err", err);
      //       }
      //     );
      // } else {
        let token = this.$cookies.get("hbscToken") || sessionStorage.getItem("hbscToken");
        let url = `https://hzy.haier.com/cn/vipcode/payingMember?needAuthLogin=1&accountToken=${token}`;
        window.location.href = url;
      // }
    },
    async getList(){
      let params = {
        "pageNum": 1,
        "pageSize": 10
      }
      let res = await findPlusProductList(params);
      if (res.code === "0000") {
        if (res.result != null) {
          this.productLists = res.result.list;
        }
      }
    },
     async ifPlus(){
      let that = this;
       const memberId =
        this.$cookies.get("memberId") ||
        sessionStorage.getItem("memberId") ||
        "";
      let res = await isMemberPlus({buyerId:memberId});
       console.log(res,"----------res")
      if (res.code === "0000") {
        that.ifplus = res.data;
        console.log(that.ifplus,"this.ifplus")
      }
    },
     // 展示
    handleScroll() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top > window.screen.height) {
        this.toTop = true;
      } else {
        this.toTop = false;
      }
    },
    // 回到顶部
    backTop(speed) {
      // 滚动到顶部
      let _this = this;
      //home-content为需要被滚动到顶部的元素
      //let element = document.body；
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      this.timer = setInterval(function () {
        top -= speed;
        if (top <= 1) {
          top = 0;
          clearInterval(_this.timer);
        }
        document.documentElement.scrollTop = document.body.scrollTop = top;
      }, 20);
    },
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    let recruitScrollY = this.$route.query.page
    window.scroll(0, recruitScrollY)
    this.getList()
    this.ifPlus()
    this.ip = returnCitySN["cip"];


  },
   deactivated() {
    clearInterval(this.timer);
  },
};
</script>
<style lang='scss' scoped>
.contianer{
  background: #0E1647;
  padding-bottom: 60px;
}

img {
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 100%;
}
.btnbox{
  margin-top: -120px;
  img{
    width: 75%;
    display: block;
    margin: auto;
  }
}
.ptitle{
  margin-top: 80px;

  img{
    width: 30%;
    margin: auto;
    display: block;

  }
  div{
    color: #FCDFB6;
    text-align: center;
    margin: auto;
    margin-top: 20px;
    background: linear-gradient(92.06deg, #6E512D 14.46%, #98682E 56.82%, #CDA16B 67.54%, #94662E 78.63%, #825C2D 92.54%);
    border-radius: 24px;
    width: 60%;
    height: 40px;
    line-height: 42px;
    letter-spacing: 3px;
    font-size: 24px;

  }
  .icon2{
    width: 40%;
  }
}
.plist{
  padding: 40px 24px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .pbox{
    width: 48%;
    border-radius: 24px;
    background-color: #fff;
    overflow: hidden;
    margin:10px 4px;
    img{
      width: 100%;
    }
    .title{
      font-family: 'PingFang SC';
      font-style: normal;
      color: #111111;
      font-weight: 500;
      font-size: 30px;
      padding: 8px 12px 0 12px;
      overflow: hidden;
      -webkit-line-clamp: 2;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .proicon{
      width: 100px;
      vertical-align: inherit;
      margin-right: 8px;
    }
    .jf{
      color: #E8A12C;
       padding: 10px 20px;
       font-size: 28px;
    }
  }
}
.backtop{
  position: fixed;
  width: 80px;
  bottom: 20px;
  right: 20px;
}
</style>